var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourglassFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1q0 2.039-0.832 3.605t-2.082 2.395q1.25 0.828 2.082 2.395t0.832 3.605h0.75q0.109 0 0.18 0.070t0.070 0.18v0.5q0 0.109-0.070 0.18t-0.18 0.070h-11.5q-0.109 0-0.18-0.070t-0.070-0.18v-0.5q0-0.109 0.070-0.18t0.18-0.070h0.75q0-2.039 0.832-3.605t2.082-2.395q-1.25-0.828-2.082-2.395t-0.832-3.605h-0.75q-0.109 0-0.18-0.070t-0.070-0.18v-0.5q0-0.109 0.070-0.18t0.18-0.070h11.5q0.109 0 0.18 0.070t0.070 0.18v0.5q0 0.109-0.070 0.18t-0.18 0.070h-0.75zM10 1h-8q0 0.516 0.070 1h7.859q0.070-0.477 0.070-1zM10 13q0-1.016-0.266-1.949t-0.707-1.625-0.988-1.187-1.141-0.738h-1.797q-0.594 0.242-1.141 0.738t-0.988 1.187-0.707 1.625-0.266 1.949h8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassFull);
export default __webpack_public_path__ + "static/media/hourglass-full.f03b2ab7ca92f6198d10c5a7221370cf.svg";
export { ForwardRef as ReactComponent };